import { DEFAULT_TABLE_PAGE_SIZE } from 'src/constants/Pagination';

import { type JobConfigPageState } from './types';

// Using function to get a deepClone every time
export const JobConfigTableFilterInitialeState = (): JobConfigPageState['jobConfigTableFilter'] => ({
  jobNames: [],
  regions: [],
  types: [],
  siteTypes: [],
  isActiveSelections: [],
});

export const initialState: JobConfigPageState = {
  isLoading: true,
  tableData: [],
  currentPage: 1,
  perPage: DEFAULT_TABLE_PAGE_SIZE,
  totalPages: 0,
  searchField: '',
  createdJobSuccessfully: false,
  isJobConfigTableFilterSheetOpen: false,
  jobConfigTableFilterOptions: JobConfigTableFilterInitialeState(),
  jobConfigTableFilter: {
    jobNames: [],
    regions: [],
    types: [],
    siteTypes: [],
    isActiveSelections: [],
  },
  jobConfigTableFilterTags: [],
};
